// S2 Task 2-A — 공유 뷰어(client) 모드 단일 플래그 (SSOT).
// ClientApp 마운트 시 true. 저장 계층(safeStorage/brandStorage)의 brand write 거부 기준.
// 의존 없는 leaf 모듈 — safeStorage·brandStorage 양쪽에서 import(순환 회피).
let _client = false;

export function setClientMode(flag) {
  _client = Boolean(flag);
}

export function isClientMode() {
  return _client;
}
